module.exports = __webpack_public_path__ + "./docs/img/icon-chevron.099d8b195ce4aba4e4f0ad8d3024e2a6.svg";